import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcknowledgeFormComponent } from './components/acknowledge-form/acknowledge-form.component';
import { InputModule } from '../input/input.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { IntlInputModule } from '../intl-input/intl-input.module';
import { ButtonModule } from '../button/button.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputModule,
    SharedModule,
    IntlInputModule,
    ButtonModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatCheckboxModule
  ],
  declarations: [AcknowledgeFormComponent],
  exports: [AcknowledgeFormComponent]
})
export class AcknowledgeFormModule { }
